const detect = u => {
    u = u || navigator.userAgent
    let vm = {},
        match = {
            //内核
            'Trident': u.indexOf('Trident') > -1 || u.indexOf('NET CLR') > -1,
            'Presto': u.indexOf('Presto') > -1,
            'WebKit': u.indexOf('AppleWebKit') > -1,
            'Gecko': u.indexOf('Gecko/') > -1,
            //浏览器
            'Safari': u.indexOf('Safari') > -1,
            'Edge': u.indexOf('Edge') > -1 || u.indexOf('Edg') > -1,
            'Chrome': u.indexOf('Chrome') > -1 || u.indexOf('CriOS') > -1,
            'IE': u.indexOf('MSIE') > -1 || u.indexOf('Trident') > -1,
            'Firefox': u.indexOf('Firefox') > -1 || u.indexOf('FxiOS') > -1,
            'Firefox Focus': u.indexOf('Focus') > -1,
            'Chromium': u.indexOf('Chromium') > -1,
            'Opera': u.indexOf('Opera') > -1 || u.indexOf('OPR') > -1,
            'Vivaldi': u.indexOf('Vivaldi') > -1,
            'Yandex': u.indexOf('YaBrowser') > -1,
            'Kindle': u.indexOf('Kindle') > -1 || u.indexOf('Silk/') > -1,
            '360': u.indexOf('360EE') > -1 || u.indexOf('360SE') > -1,
            'UC': u.indexOf('UC') > -1 || u.indexOf(' UBrowser') > -1,
            'QQBrowser': u.indexOf('QQBrowser') > -1,
            'QQ': u.indexOf('QQ/') > -1,
            'Baidu': u.indexOf('Baidu') > -1 || u.indexOf('BIDUBrowser') > -1,
            'Maxthon': u.indexOf('Maxthon') > -1,
            'Sogou': u.indexOf('MetaSr') > -1 || u.indexOf('Sogou') > -1,
            'LBBROWSER': u.indexOf('LBBROWSER') > -1,
            '2345Explorer': u.indexOf('2345Explorer') > -1,
            'TheWorld': u.indexOf('TheWorld') > -1,
            'XiaoMi': u.indexOf('MiuiBrowser') > -1,
            'Quark': u.indexOf('Quark') > -1,
            'Qiyu': u.indexOf('Qiyu') > -1,
            'Wechat': u.indexOf('MicroMessenger') > -1,
            'Taobao': u.indexOf('AliApp(TB') > -1,
            'Alipay': u.indexOf('AliApp(AP') > -1,
            'Weibo': u.indexOf('Weibo') > -1,
            'Douban': u.indexOf('com.douban.frodo') > -1,
            'Suning': u.indexOf('SNEBUY-APP') > -1,
            'iQiYi': u.indexOf('IqiyiApp') > -1,
            //系统或平台
            'Windows': u.indexOf('Windows') > -1,
            'Linux': u.indexOf('Linux') > -1 || u.indexOf('X11') > -1,
            'macOS': u.indexOf('Macintosh') > -1,
            'Android': u.indexOf('Android') > -1 || u.indexOf('Adr') > -1,
            'Ubuntu': u.indexOf('Ubuntu') > -1,
            'FreeBSD': u.indexOf('FreeBSD') > -1,
            'Debian': u.indexOf('Debian') > -1,
            'Windows Phone': u.indexOf('IEMobile') > -1 || u.indexOf('Windows Phone')>-1,
            'BlackBerry': u.indexOf('BlackBerry') > -1 || u.indexOf('RIM') > -1 || u.indexOf('BB10') > -1,
            'MeeGo': u.indexOf('MeeGo') > -1,
            'Symbian': u.indexOf('Symbian') > -1,
            'iOS': u.indexOf('like Mac OS X') > -1,
            'Chrome OS': u.indexOf('CrOS') > -1,
            'WebOS': u.indexOf('hpwOS') > -1,
            //设备
            'Mobile': u.indexOf('Mobi') > -1 || u.indexOf('iPh') > -1 || u.indexOf('480') > -1,
            'Tablet': u.indexOf('Tablet') > -1 || u.indexOf('Pad') > -1 || u.indexOf('Nexus 7') > -1
        };
    //修正
    if (match['Mobile']) match['Mobile'] = !(u.indexOf('iPad') > -1);
    //基本信息
    let _hash = {
        browser: ['Safari', 'Chrome', 'Edge', 'IE', 'Firefox', 'Firefox Focus', 'Chromium', 'Opera', 'Vivaldi', 'Yandex', 'Kindle', '360', 'UC', 'QQBrowser', 'QQ', 'Baidu', 'Maxthon', 'Sogou', 'LBBROWSER', '2345Explorer', 'TheWorld', 'XiaoMi', 'Quark', 'Qiyu', 'Wechat', 'Taobao', 'Alipay', 'Weibo', 'Douban','Suning', 'iQiYi'],
        os: ['Windows', 'Linux', 'Mac OS', 'macOS', 'Android', 'Ubuntu', 'FreeBSD', 'Debian', 'iOS', 'Windows Phone', 'BlackBerry', 'MeeGo', 'Symbian', 'Chrome OS', 'WebOS']
    };
    for (let s in _hash) {
        if(_hash.hasOwnProperty(s)){
            for (let i = 0,len = _hash[s].length; i < len; i++) {
                let v = _hash[s][i];
                if (match[v]) vm[s] = v;
            }
        }
    }
    //系统版本信息
    let osVersion = {
        'Windows': function () {
            let v = u.replace(/^.*Windows NT ([\d.]+).*$/, '$1'),
                hash = {
                    '6.4': '10',
                    '6.3': '8.1',
                    '6.2': '8',
                    '6.1': '7',
                    '6.0': 'Vista',
                    '5.2': 'XP',
                    '5.1': 'XP',
                    '5.0': '2000'
                };
            return hash[v] || v;
        },
        'Android': u.replace(/^.*Android ([\d.]+);.*$/, '$1'),
        'iOS': u.replace(/^.*OS ([\d_]+) like.*$/, '$1').replace(/_/g, '.'),
        'Debian': u.replace(/^.*Debian\/([\d.]+).*$/, '$1'),
        'Windows Phone': u.replace(/^.*Windows Phone( OS)? ([\d.]+);.*$/, '$2'),
        'macOS': u.replace(/^.*Mac OS X ([\d_]+).*$/, '$1').replace(/_/g, '.'),
        'WebOS': u.replace(/^.*hpwOS\/([\d.]+);.*$/, '$1'),
        'BlackBerry': u.replace(/^.*BB([\d.]+);*$/, '$1')
    }
    vm['osVersion'] = '';
    let osv = osVersion[vm.os]
    if (osv) vm.osVersion = typeof osv === 'function' ? osv() : (osv == u ? '' : osv);
    //浏览器版本信息
    var version = {
        'Safari': u.replace(/^.*Version\/([\d.]+).*$/, '$1'),
        'Chrome': u.replace(/^.*Chrome\/([\d.]+).*$/, '$1').replace(/^.*CriOS\/([\d.]+).*$/, '$1'),
        'IE': u.replace(/^.*MSIE ([\d.]+).*$/, '$1').replace(/^.*rv:([\d.]+).*$/, '$1'),
        'Edge': u.replace(/^.*Edge?\/([\d.]+).*$/, '$1'),
        'Firefox': u.replace(/^.*Firefox\/([\d.]+).*$/, '$1').replace(/^.*FxiOS\/([\d.]+).*$/, '$1'),
        'Firefox Focus': u.replace(/^.*Focus\/([\d.]+).*$/, '$1'),
        'Chromium': u.replace(/^.*Chromium\/([\d.]+).*$/, '$1'),
        'Opera': u.replace(/^.*Opera\/([\d.]+).*$/, '$1').replace(/^.*OPR\/([\d.]+).*$/, '$1'),
        'Vivaldi': u.replace(/^.*Vivaldi\/([\d.]+).*$/, '$1'),
        'Yandex': u.replace(/^.*YaBrowser\/([\d.]+).*$/, '$1'),
        'Kindle': u.replace(/^.*Version\/([\d.]+).*$/, '$1'),
        'Maxthon': u.replace(/^.*Maxthon\/([\d.]+).*$/, '$1'),
        'QQBrowser': u.replace(/^.*QQBrowser\/([\d.]+).*$/, '$1'),
        'QQ': u.replace(/^.*QQ\/([\d.]+).*$/, '$1'),
        'Baidu': u.replace(/^.*BIDUBrowser[\s\/]([\d.]+).*$/, '$1'),
        'UC': u.replace(/^.*UC?Browser\/([\d.]+).*$/, '$1'),
        'Sogou': u.replace(/^.*SE ([\d.X]+).*$/, '$1').replace(/^.*SogouMobileBrowser\/([\d.]+).*$/, '$1'),
        '2345Explorer': u.replace(/^.*2345Explorer\/([\d.]+).*$/, '$1'),
        'TheWorld': u.replace(/^.*TheWorld ([\d.]+).*$/, '$1'),
        'XiaoMi': u.replace(/^.*MiuiBrowser\/([\d.]+).*$/, '$1'),
        'Quark': u.replace(/^.*Quark\/([\d.]+).*$/, '$1'),
        'Qiyu': u.replace(/^.*Qiyu\/([\d.]+).*$/, '$1'),
        'Wechat': u.replace(/^.*MicroMessenger\/([\d.]+).*$/, '$1'),
        'Taobao': u.replace(/^.*AliApp\(TB\/([\d.]+).*$/, '$1'),
        'Alipay': u.replace(/^.*AliApp\(AP\/([\d.]+).*$/, '$1'),
        'Weibo': u.replace(/^.*weibo__([\d.]+).*$/, '$1'),
        'Douban': u.replace(/^.*com.douban.frodo\/([\d.]+).*$/, '$1'),
        'Suning': u.replace(/^.*SNEBUY-APP([\d.]+).*$/, '$1'),
        'iQiYi': u.replace(/^.*IqiyiVersion\/([\d.]+).*$/, '$1')
    };
    vm['version'] = '';
    let bsv = version[vm.browser]
    if (bsv) vm.version = typeof bsv === 'function' ? bsv() : (bsv == u ? '' : bsv);
    //修正
    if (vm.browser == undefined) vm.browser = 'Unknow App'
    return vm
};

export default detect